import React, { Component, Fragment } from 'react';
import { Card, TableContainer, Table, TableBody, TableHead, TableRow, TableCell, Box, Link, ListItem, ListItemIcon, ListItemText, CardContent, CardActions, Button } from '@material-ui/core';
import { AddCircleRounded, AddCircleOutlineRounded} from '@material-ui/icons';
import { connect } from 'react-redux';

import { read, utils, writeFile } from 'xlsx';
import Papa from 'papaparse';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import Paper from '@material-ui/core/Paper';

class FormTableTitle extends Component {
    state = {  }
    render() {
        const { title, color } = this.props;
        return (
            <Box p={2} className={(color ? color : "bgm-bluegray ")}>
                <h4 className="text-center c-white"><i>{title}</i></h4>
            </Box>
        );
    }
}
            
export class FormTableTh extends Component {
    state = {  }
    render() {
        const { showTVA, isTVAExempt } = this.props;
        return (
           
            <thead>
                <TableRow>
                    <TableCell style={{minWidth:'500px'}}>Produit</TableCell>
                    <TableCell style={{minWidth:'120px'}}>Quantité</TableCell>
                    <TableCell style={{minWidth:'150px'}}>Prix Unitaire</TableCell>
                    {showTVA && <TableCell style={{minWidth:'100px'}}>TVA (%)</TableCell>}
                    <TableCell style={{minWidth:'200px'}}>{!showTVA || isTVAExempt ? 'TOTAL HT' : 'TOTAL TTC'}</TableCell>
                </TableRow>
            </thead>
        );
    }
}
                    
export class ReaTableTh extends Component {
    state = {  }
    render() {
        return (
           
            <TableHead>
                <TableRow>
                    <TableCell style={{minWidth:'300px'}}>Produit</TableCell>
                    <TableCell style={{minWidth:'150px'}}>Quantité</TableCell>
                </TableRow>
            </TableHead>
                    
        );
    }
}

export class OrderTableTh extends Component {
    state = {  }
    render() {

        return (
           
            <TableHead>
                <TableRow>
                    <TableCell style={{minWidth:'300px'}}>Magasin</TableCell>
                    <TableCell style={{minWidth:'150px'}}>Quantité</TableCell>
                </TableRow>
            </TableHead>
                    
        );
    }
}



class FormLayout extends Component {
    //state = {  }
    state = {
        open: false,
        data: [],
        isValid: [],
      };
    
      handleClickOpen = () => {
        this.setState({ open: true });
      };

      handleDownloadTemplate = () => {
        const header = ['ProductRef', 'ID product', 'Quantity', 'Total Price'];
        const sampleRow = ['REF-0001', 'PRD-001', 10, 150000];
        const worksheet = utils.aoa_to_sheet([header, sampleRow]);
        const workbook = utils.book_new();
        utils.book_append_sheet(workbook, worksheet, 'Template');
        writeFile(workbook, 'template_import_stock.xlsx');
      };
    
      handleRemoveList = () =>{
            this.setState({ data: [] });
      };
      handleClose = () => {
        this.setState({  open: false  });
      };
    
      checkProductName = (row) =>{
        console.log("checkProductName >> product ID",row[0])
        const  { AVAILABLE, PRODUCTS } = this.props
        console.log("checkProductName >> product ID AVAILABLE",PRODUCTS)

        if(PRODUCTS){
            const product = Object.values(PRODUCTS).find(product => product.ref === row[0]);
            if (product) {
              console.log("checkProductName found", product);
              return {productName : product.marque + "-" + product.name,productInfo: product};
            }
        }
        return {productName :"",productInfo: {} };
      };
      handleFileUpload = (event) => {
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = new Uint8Array(e.target.result);
          const workbook = read(data, { type: 'array' });
          const sheetName = workbook.SheetNames[0];
          const sheet = workbook.Sheets[sheetName];
          const jsonData = utils.sheet_to_json(sheet, { header: 1 });
          const  dataTmp = jsonData.slice(1)// skip the header row
          console.log("handleFileUpload, data => ",dataTmp)
          const dataConverted = dataTmp.filter((row) => row.length == 3).map((row) => {
            const productInfo = this.checkProductName(row); // Replace with your function to calculate the new value
            var checked = true
            if (productInfo.productName === ""){
                checked = false
            }
            return [ productInfo.productName,...row ,checked,productInfo.productInfo];
          });
          console.log("handleFileUpload, dataConverted => ",dataConverted)

          this.setState({
            data: dataConverted, 
            isValid: Array(jsonData.length - 1).fill(false), // initialize validation array
          });
          event.target.value = null;
        };
        reader.readAsArrayBuffer(file);
      };
    
      handleValidation = (index, isValid) => {
        this.setState((prevState) => ({
          isValid: [
            ...prevState.isValid.slice(0, index),
            isValid,
            ...prevState.isValid.slice(index + 1),
          ],
        }));
      };
    
      handleSubmit = () => {
        // Vous pouvez ici ajouter votre logique pour envoyer les données du CSV et les résultats de la validation
        console.log('CSV data:', this.state.data);
        console.log('Validation results:', this.state.isValid);
        this.props.onClickForCSVUpload(this.state.data)
        this.handleClose();
      };
    render() {
        const { title, color, children, rea, order, colSpan, onClick, disabled, showTVA, isTVAExempt } = this.props;
        console.log("RENDER FormLayout ")
        return (
            <Box p={1}>
                {title &&
                    <FormTableTitle title={title} color={color} />
                }
                
                <TableContainer>
                    <Table className="table table-striped table-bordered">
                        { rea &&
                            <ReaTableTh />
                        }
                        {!rea && !order &&
                            <FormTableTh showTVA={showTVA} isTVAExempt={isTVAExempt} />
                        }
                        {order &&
                            <OrderTableTh />
                        }
                        
                        <TableBody>
                            {children ||
                            <Fragment>
                                {this.props.createAddForm}
                                <TableRow className="plus-btn" onClick={onClick}>
                                    <TableCell colSpan={colSpan}>
                                        <Link color="secondary"> 
                                            {/* <AddCircleOutlineRounded />
                                            <span>Ajouter un produit</span>  */}
                                            {/* <ListItem>
                                                <ListItemIcon>
                                                    <AddCircleOutlineRounded />
                                                </ListItemIcon>
                                                <ListItemText primary="Ajouter un produit" />
                                            </ListItem> */}
                                            <Button color="secondary" startIcon={<AddCircleRounded />} disabled={disabled}>
                                                <b>Ajouter un produit</b>
                                            </Button>
                                        </Link>
                                    </TableCell>
                                </TableRow>
                                <TableRow className="plus-btn" onClick={this.handleClickOpen}>
                                    <TableCell colSpan={colSpan}>
                                        <Link color="secondary">
                                            <Button color="secondary" startIcon={<AddCircleOutlineRounded />} disabled={disabled}>
                                                <b>Ajouter une liste de produit par CSV</b>
                                            </Button>
                                        </Link>
                                    </TableCell>
                                </TableRow>
                            </Fragment>
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
                <Dialog open={this.state.open} onClose={this.handleClose} fullWidth maxWidth="md">
          <DialogTitle>Télécharger un fichier XLS</DialogTitle>
          <DialogContent>
            <input type="file" accept=".xlsx,.xls" onChange={this.handleFileUpload} />
            <Box mt={2}>
              <Button variant="outlined" color="secondary" onClick={this.handleDownloadTemplate}>
                Télécharger le template
              </Button>
            </Box>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Product Name</TableCell>
                    <TableCell>ID product</TableCell>
                    <TableCell>Quantity</TableCell>
                    <TableCell>Total Price</TableCell>
                    <TableCell>Valide</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.data.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>{row[0]}</TableCell>
                      <TableCell>{row[1]}</TableCell>
                      <TableCell>{row[2]}</TableCell>
                      <TableCell>{row[3]}</TableCell>
                      <TableCell>
                        <Checkbox
                          checked={row[4]}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </DialogContent>
          <DialogActions>
          <Button onClick={this.handleRemoveList} color="primary">
              Supprimer liste
            </Button>
            <Button onClick={this.handleClose} color="primary">
              Annuler
            </Button>
            <Button onClick={this.handleSubmit} color="primary">
              Envoyer
            </Button>
          </DialogActions>
        </Dialog>
            </Box>
        );
    }
}


export default FormLayout;
